import { isDefined } from '@duke-hq/lib';

export function getFieldPlaceholder(fieldType: string, label: string, placeholder?: string | null) {
  if (isDefined(placeholder) && placeholder.length > 0) {
    return placeholder;
  }

  const fallbackPrefix = fieldType === 'TEXT' ? 'Enter' : 'Select';
  return `${fallbackPrefix} ${label.toLowerCase()}`;
}
